export default "__VITE_ASSET__CfpEtoxI__"